export const WEBHOOK = "WEBHOOK";

export const METHOD_OPTIONS = [
  { label: "GET", value: "GET" },
  { label: "POST", value: "POST" },
  { label: "PUT", value: "PUT" },
  { label: "DELETE", value: "DELETE" },
  { label: "HEAD", value: "HEAD" },
  { label: "OPTIONS", value: "OPTIONS" },
  { label: "PATCH", value: "PATCH" },
  { label: "TRACE", value: "TRACE" },
];

export const JSONPATH = "JSON_PATH";
export const ITERATOR = "ITERATOR";
export const DATA_CONDITION = "DATA_CONDITION";
export const HTTP_CONDITION = "HTTP_CONDITION";

export const OPTIONS = [
  { label: "JSON Path Variable", value: JSONPATH },
  { label: "Iterator", value: ITERATOR },
  { label: "Data Condition", value: DATA_CONDITION },
  { label: "HTTP Status Condition", value: HTTP_CONDITION },
];

export const defaultHTTPHeaders = [
  {
    label: "Access-Control-Allow-Credentials",
    value: "Access-Control-Allow-Credentials",
  },
  {
    label: "Access-Control-Allow-Headers",
    value: "Access-Control-Allow-Headers",
  },
  {
    label: "Access-Control-Allow-Methods",
    value: "Access-Control-Allow-Methods",
  },
  {
    label: "Access-Control-Allow-Origin",
    value: "Access-Control-Allow-Origin",
  },
  {
    label: "Access-Control-Expose-Headers",
    value: "Access-Control-Expose-Headers",
  },
  {
    label: "Access-Control-Max-Age",
    value: "Access-Control-Max-Age",
  },
  {
    label: "Accept-Ranges",
    value: "Accept-Ranges",
  },
  {
    label: "Age",
    value: "Age",
  },
  {
    label: "Allow",
    value: "Allow",
  },
  {
    label: "Alternate-Protocol",
    value: "Alternate-Protocol",
  },
  {
    label: "Cache-Control",
    value: "Cache-Control",
  },
  {
    label: "Client-Date",
    value: "Client-Date",
  },
  {
    label: "Client-Peer",
    value: "Client-Peer",
  },
  {
    label: "Client-Response-Num",
    value: "Client-Response-Num",
  },
  {
    label: "Connection",
    value: "Connection",
  },
  {
    label: "Content-Disposition",
    value: "Content-Disposition",
  },
  {
    label: "Content-Encoding",
    value: "Content-Encoding",
  },
  {
    label: "Content-Language",
    value: "Content-Language",
  },
  {
    label: "Content-Length",
    value: "Content-Length",
  },
  {
    label: "Content-Location",
    value: "Content-Location",
  },
  {
    label: "Content-MD5",
    value: "Content-MD5",
  },
  {
    label: "Content-Range",
    value: "Content-Range",
  },
  {
    label: "Content-Security-Policy  X-Content-Security-Policy  X-WebKit-CSP",
    value: "Content-Security-Policy  X-Content-Security-Policy  X-WebKit-CSP",
  },
  {
    label: "Content-Security-Policy-Report-Only",
    value: "Content-Security-Policy-Report-Only",
  },
  {
    label: "Content-Type",
    value: "Content-Type",
  },
  {
    label: "Date",
    value: "Date",
  },
  {
    label: "ETag",
    value: "ETag",
  },
  {
    label: "Expires",
    value: "Expires",
  },
  {
    label: "HTTP",
    value: "HTTP",
  },
  {
    label: "Keep-Alive",
    value: "Keep-Alive",
  },
  {
    label: "Last-Modified",
    value: "Last-Modified",
  },
  {
    label: "Link",
    value: "Link",
  },
  {
    label: "Location",
    value: "Location",
  },
  {
    label: "P3P",
    value: "P3P",
  },
  {
    label: "Pragma",
    value: "Pragma",
  },
  {
    label: "Proxy-Authenticate",
    value: "Proxy-Authenticate",
  },
  {
    label: "Proxy-Connection",
    value: "Proxy-Connection",
  },
  {
    label: "Refresh",
    value: "Refresh",
  },
  {
    label: "Retry-After",
    value: "Retry-After",
  },
  {
    label: "Server",
    value: "Server",
  },
  {
    label: "Set-Cookie",
    value: "Set-Cookie",
  },
  {
    label: "Status",
    value: "Status",
  },
  {
    label: "Strict-Transport-Security",
    value: "Strict-Transport-Security",
  },
  {
    label: "Timing-Allow-Origin",
    value: "Timing-Allow-Origin",
  },
  {
    label: "Trailer",
    value: "Trailer",
  },
  {
    label: "Transfer-Encoding",
    value: "Transfer-Encoding",
  },
  {
    label: "Upgrade",
    value: "Upgrade",
  },
  {
    label: "Vary",
    value: "Vary",
  },
  {
    label: "Via",
    value: "Via",
  },
  {
    label: "Warning",
    value: "Warning",
  },
  {
    label: "WWW-Authenticate",
    value: "WWW-Authenticate",
  },
  {
    label: "X-Aspnet-Version",
    value: "X-Aspnet-Version",
  },
  {
    label: "X-Content-Type-Options",
    value: "X-Content-Type-Options",
  },
  {
    label: "X-Frame-Options",
    value: "X-Frame-Options",
  },
  {
    label: "X-Permitted-Cross-Domain-Policies",
    value: "X-Permitted-Cross-Domain-Policies",
  },
  {
    label: "X-Pingback",
    value: "X-Pingback",
  },
  {
    label: "X-Powered-By",
    value: "X-Powered-By",
  },
  {
    label: "X-Robots-Tag",
    value: "X-Robots-Tag",
  },
  {
    label: "X-UA-Compatible",
    value: "X-UA-Compatible",
  },
  {
    label: "X-XSS-Protection",
    value: "X-XSS-Protection",
  },
  {
    label: "X-Atlassian-Token",
    value: "X-Atlassian-Token",
  },
];
export const httpHeaderTableHead = {
  cells: [
    {
      content: "Key",
      key: "httpkey",
      isSortable: true,
      width: 35,
    },
    {
      content: "Value",
      key: "value",
      isSortable: true,
      width: 35,
    },
    {
      content: "Action",
      key: "action",
      isSortable: true,
      width: 15,
    },
  ],
};
export const jsonPathTableHeaders = {
  cells: [
    {
      content: "Name",
      key: "name",
      isSortable: true,
      width: 35,
    },
    {
      content: "JSON Path",
      key: "jsonPath",
      isSortable: true,
      width: 35,
    },
    {
      content: "Action",
      key: "action",
      isSortable: true,
      width: 15,
    },
  ],
};
export const flowVarTableHeaders = {
  cells: [
    {
      content: "Name (optional JSON Path)",
      key: "name",
      isSortable: true,
      width: 35,
    },
    {
      content: "Value (optional JSON Path)",
      key: "jsonPath",
      isSortable: true,
      width: 35,
    },
    {
      content: "Behavior",
      key: "behavior",
      isSortable: true,
      width: 20,
    },
    {
      content: "Name Property",
      key: "behavior_instruction",
      isSortable: true,
      width: 35,
    },
    {
      content: "Action",
      key: "action",
      isSortable: true,
      width: 15,
    },
  ],
};
export const conditionHeaders = {
  cells: [
    {
      content: "Only continue if…",
      key: "definition",
      isSortable: true,
      width: 100,
    },
  ],
};
